import {api} from '@/api'
import * as types from '@/store/mutation-types'
import local from '@/localStorage'

/**
 * Analyzes meta information.
 *
 * @param {object} data json response from API.
 * @return {object[array,boolean]} data and if there are more to fetch.
 */
export const checkResponse = ({data}) => {
  if (!data) return null

  // true if there is next attribute
  const hasNextPage = data && data.meta && data.meta.pagination &&
    data.meta.pagination.links && data.meta.pagination.links.next

  return {data: [...data.data], next: !!hasNextPage}
}

export const sanitizeParams = type => params => {
  const types = {
    pubs: {
      lat: 'number',
      lon: 'number',
      distance: 'integer',
      user_agent: 'string',
      page: 'integer',
      per_page: 'integer'
    },

    ads: {
      lat: 'number',
      lon: 'number',
      distance: 'integer',
      user_agent: 'string',
      per_page: 'integer'
    }
  }

  const res = {}
  for (let i in types[type]) {
    // value from input
    let val = params[i]

    if (val || val === 0) {
      // type from constrictions
      let t = types[type][i]

      switch (t) {
        case 'number':
          if (typeof val === 'number') res[i] = val
          break
        case 'string':
          if (typeof val === 'string') res[i] = val
          break
        case 'integer':
          if (Number.isInteger(val)) res[i] = val
          break
        default:
      }
    }
  }
  return res
}

export const authSuccessful = commit => ({data}) => {
  if (data.token_type === 'Bearer') {
    const token = data.access_token
    const refresh = data.refresh_token
    // adds token to header's requests
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    // update state
    commit(types.SET_USER_TOKEN, token)
    commit(types.SET_USER_REFRESH, refresh)
    commit(types.USER_LOGIN)
    commit(types.USER_SET_AWAITING, false)

    local.setTokens({bearer: token, refresh})

    return token
  }
}



// WEBPACK FOOTER //
// ./src/store/helpers.js